import { Vyjadrenia, PripomienkovanieApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import dateToString from '../../function/dateToString';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new PripomienkovanieApi(apiConfiguration(elegislativaPrefixPath));

const map = (
  durationDays: number,
  startDate: Date,
): Vyjadrenia => ({
  durationDays: durationDays || 0,
  startDate: startDate ? dateToString(startDate) : null,
});

// eslint-disable-next-line import/prefer-default-export
export const startVyjadrenia = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: string,
  durationDays: number,
  startDate: Date,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const vyjadrenia = map(durationDays, startDate);
  const { status } = await client.startVyjadrenia(type, year, index, pracovnyKrokId, vyjadrenia, headers);
  return {
    responseCode: status,
  };
};
